import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { IntentStyle } from '../common/props';

type Props = {
  className?: string;
  children?: React.ReactNode;
  /**
   * Pokud je true, jedná se o loader, který není jako standardní div, ale objeví se NAD ostatními elementami, napřo pro využití v seznamech apod.
   */
  hover?: boolean;
  transparent?: boolean;
  intent?: IntentStyle;
};

export const HorizontalLoader = ({
  className,
  hover,
  transparent,
  intent = 'primary',
  ...other
}: Props) => {
  const clsCont = classNames(className, Classes.HORIZONTAL_LOADER, className, {
    hover,
    [Classes.INTENT_PRIMARY]: intent === 'primary',
    [Classes.INTENT_DANGER]: intent === 'danger',
    [Classes.INTENT_SUCCESS]: intent === 'success',
    [Classes.INTENT_WARNING]: intent === 'warning',
    [Classes.HORIZONTAL_LOADER_TRANSPARENT]: transparent,
  });
  const cls = classNames(Classes.HORIZONTAL_LOADER_INNER);
  return (
    <div className={clsCont}>
      <div className={cls} {...other}></div>
    </div>
  );
};
